import Cookies from 'js-cookie'

import { MAGIC_LINK_COOKIE } from './constants'

// we want to attempt to redirect a user if the presense of a magic link cookie exists
export const isCookiesEnabled = () => {
  try {
    if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
      Cookies.get(MAGIC_LINK_COOKIE)
      return true
    }
  } catch {
    return false
  }
  return false
}
export const tryMagicLinkRedirect = () => {
  if (isCookiesEnabled()) {
    const queryString = Cookies.get(MAGIC_LINK_COOKIE)
    if (queryString != null) {
      Cookies.remove(MAGIC_LINK_COOKIE)
      // we don't want to redirect if the query string was empty.
      if (queryString !== '') {
        window.location.href = `/login${queryString}`
      }
    }
  }
}
